import React from 'react';
import Box from '@mui/material/Box';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import { CardMedia, IconButton } from '@mui/material';
import { getImageURLOnServer, getImageURLOnServerBeaconFace } from '../utils/utils';
import CancelIcon from '@mui/icons-material/Cancel';

interface Props {
  readonly: boolean;
  imageId?: string;
  imageURL?: string;
  modal?: boolean;
  onDelete?: () => void;
}

const FileUpload: React.FC<Props> = ({ readonly, imageId, imageURL, modal = false, onDelete }) => {
  const isReadOnly = readonly;

  const handleDeleteClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onDelete) {
      onDelete();
    }
  };

  return (
    <Box
      sx={{
        position: 'relative',
        '& ul': {
          listStyle: 'none',
          padding: 0,
        },
        zIndex: 10,
      }}
    >
      {(imageId || imageURL) && onDelete && !isReadOnly && (
        <IconButton
          onClick={handleDeleteClick}
          sx={{
            position: 'absolute',
            top: 4,
            left: 4,
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            borderRadius: '50%',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 1)',
            },
          }}
          size="small"
        >
          <CancelIcon sx={{ color: 'red', fontSize: 18 }} />
        </IconButton>
      )}
      <Box
        sx={{
          border: "silver solid 1px",
          borderRadius: 2.5,
          p: 3,
          textAlign: 'center',
          color: 'text.secondary',
          backgroundColor: 'background.default',
          alignContent: 'center',
          width: 128,
          height: 128
        }}
      >
        {imageId || imageURL ? (
          modal ? (
            <CardMedia
            sx={{ width: "100%", height: "100%", objectFit: "cover", overflow: "hidden" }}
            component="img"
            src={imageURL ? imageURL : getImageURLOnServer(imageId ?? "")}
            alt="beacon"
          />
          ) : (
            <CardMedia
            sx={{ width: "100%", height: "100%", objectFit: "cover", overflow: "hidden" }}
            component="img"
            src={imageURL ? imageURL : getImageURLOnServerBeaconFace(imageId ?? "", "")}
            alt="beacon"
          />
          )
        ) : (
          <>
          <ImageOutlinedIcon
            style={{
              fontSize: 40,
            }}
          />
        </>
        )}
      </Box>
    </Box>
  );
};

export default FileUpload;
